var App = App || {};

App.FifaModal = (function ($) {
    'use strict';

    function init() {
        // Only run on homepage
        if (!isHomePage()) {
            return;
        }

        var fifaModal = $("[id^='Modal-Fifa']").first();
        
        if (fifaModal.length === 0) {
            return;
        }

       // var modalGuid = "AppleBank_FifaModal_" + generateModalId();
        var modalGuid = fifaModal.attr("data-alertguid");
        var dismissButtons = fifaModal.find("[data-bs-dismiss='modal']");

        // Check if modal was already dismissed
        var dismissed = App.Cookies.getItem(modalGuid);
        
        if (dismissed !== "Dismissed") {
            // Show modal on page load with a slight delay
            setTimeout(function() {
                fifaModal.modal("show");
            }, 1000);
        }

        // Handle dismiss button clicks
        dismissButtons.on("click", function () {
            if (!fifaModal.attr("id").toLowerCase().includes("nodismiss")) {
                setDismissedCookie(modalGuid);
            }
        });

        // Set cookie when modal is closed by any means (backdrop click, ESC key, etc.)
        fifaModal.on("hidden.bs.modal", function () {
            var dismissed = App.Cookies.getItem(modalGuid);
            if (dismissed !== "Dismissed") {
                setDismissedCookie(modalGuid);
            }
        });
    }

    function isHomePage() {
        // Check if we're on the homepage
        // You can adjust this logic based on your URL structure
        var path = window.location.pathname;
        return path === "/" || path === "/home" || path.toLowerCase().includes("/home");
    }

    function generateModalId() {
        // Generate a consistent ID for the modal cookie
        // You can replace this with a more specific identifier if needed
        return "Modal-Fifa";
    }

    function setDismissedCookie(modalGuid) {
        App.Cookies.setItem(
            modalGuid, 
            "Dismissed", 
            Infinity, 
            "/", 
            window.location.hostname, 
            window.location.protocol === "https:"
        );
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.FifaModal.init();
});
